import IconLogoPerson2 from "assets/svg/IconLogoPerson2.svg";
import costImage from "assets/images/costImage.png";
import incomeImage from "assets/images/incomeImage.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import avatar from "assets/images/AvatarIcon.svg";

import BasicButton from "components/BasicInputs/BasicButton";
import { apiPersonsList } from "api/personApi";
import { appSetModal } from "store/actions/appAction";
import PlusIcon from "assets/icons/PlusIcon";
import Card, { CardProps } from "./Card";
import { apiFactorsList } from "api/factorApi";
import { apiGetAccountingTypes } from "api/accountingTypeApi";
import { ClickAwayListener } from "@mui/material";
import getCurrency from "helpers/currencyHelper";
import { formatPrice, getDefaultCurrency, setSelectItemLabels } from "helpers";
import { MiladiToJalali } from "helpers/dataFormat";

export interface SourceCardProps {
  onChange?: (data: any) => void;
  onDelete?: (index: number) => void;
  onChangeEdit?: CardProps["onChangeEdit"];
  index?: number;
  defPrice?: number;
  currency?: Currency;
  type?: string;
  forceType?: string;
  info?: CardProps["info"];
  edit?: boolean;
  justShow?: boolean;
  tab?: number;
  data?: any;
}

export default function SourceCard(props: SourceCardProps) {
  const dispatch: any = useDispatch();
  const store = useSelector((state: any) => state);
  const token = store?.businessReducer.business?.token;
  // const allPerson: Person[] = store.personReducer.allPerson || [];
  // const factors: Factor[] = store.factorReducer.factors || [];
  let accountingTypes = store.accountingReducer?.accountingTypes?.all || {};
  let incomeTypes = store.accountingReducer?.accountingTypes?.income || {};
  let costTypes = store.accountingReducer?.accountingTypes?.cost || {};
  const currency = getCurrency();
  accountingTypes = {
    title: "حساب ها",
    id: "main",
    childs: accountingTypes?.childs?.map((x: any) => ({ ...x, parentId: "main" })),
  };

  const [type, setType] = useState(props.forceType || props.type || "person");
  const [data, setData] = useState<SourceData>(props.data || { price: props.defPrice });
  const [edit, setEdit] = useState(props.edit);
  useEffect(() => setData(props.data || { price: props.defPrice }), [props.data]);
  useEffect(() => setType(props.forceType || props.type || "person"), [props.type]);
  useEffect(() => setEdit(props.edit), [props.edit]);

  const factorType = props.tab === 0 ? "sale" : "buy";

  const beforeLoadingPerSelectBox: BasicSelectProps["beforeLoadingPerSelectBox"] = ({ name, params, status }) => {
    switch (name) {
      case "selectPerson":
        if (status === "beforeSendRequest") {
          params["personType"] = "allPerson"
          return params
        } else {
          const persons = setSelectItemLabels(params.persons, "id", "nickName");
          return persons.map((x: any) => ({
            ...x,
            image: x.avatar || avatar,
            dsc: `${x.mobile || ""}`,
            ind: x.accountingCode,
            title: x.nickName
          }))
        }
      case "factorListSelect": {
        if (status === "beforeSendRequest") {

          params["factorTypes"] = JSON.stringify([factorType])
          params["type"] = 'transaction'
          params["personId"] = data.person
          return params
        } else {
          const factors = setSelectItemLabels(params.factors, "id", "title");
          return factors.filter((x: any) => x.type === factorType)
            .map((x: any) => {
              const splitedArr = x.dueDate.split('-')
              const shamsiDate = MiladiToJalali(Number(splitedArr[0]), Number(splitedArr[1]), Number(splitedArr[2])) as [number,number,number]
              return ({
                ...x,
                ind: x.accountingCode,
                title: x.title + " - " + `${shamsiDate[0]}/${shamsiDate[1] < 10 ? '0' + shamsiDate[1] : ""}/${shamsiDate[2]} ` + ` - ${formatPrice(x.totalPrice)} ${getDefaultCurrency(x.CurrencyId).en_title} `,
                label: x.accountingCode + " - " + x.title + " - " + `${shamsiDate[0]}/${shamsiDate[1] < 10 ? '0' + shamsiDate[1] : ""}/${shamsiDate[2]}` + ' - ' + `${x.totalPrice} ${getDefaultCurrency(x.CurrencyId).fa_title}`,
                value: x.id,
              })
            })
          
        }
      }
    }
  }
  const inputs: CardProps["inputs"] = {
    person: {
      type: "select",
      label: "انتخاب شخص",
      options: [],
      withSearch: true,
      name: "selectPerson",
      searchColumns: "nickName,firstName,accountingCode,lastName,mobile",
      requestInfo: { method: "get", url: "/persons/list/active" },
      beforeLoadingPerSelectBox: beforeLoadingPerSelectBox,

      withRefresh: true,
      //refreshList: () => dispatch(apiPersonsList(token, "allPerson")),
      footer: (
        <Footer
          title="افزودن شخص"
          type="person"
          callBack={(token: any, res: any) => {
            dispatch(
              apiPersonsList(token, "allPerson", () => {
                handleChange(res.id, "person");
              })
            );
          }}
        />
      ),
      closeOnFooterClick: true,
      onChange: (val) => {
        handleChange(val, "person");
        // dispatch(apiFactorsList(token, JSON.stringify([factorType]), "transaction", val));
      },
    },
    factor: {
      type: "select",
      label: "انتخاب فاکتور",
      name: "factorListSelect",
      options: [],
      searchColumns: "accountingCode,date,title",
      requestInfo: { method: "get", url: "/factors/list/active" },
      beforeLoadingPerSelectBox: beforeLoadingPerSelectBox,
      // factors
      //   .filter((x) => x.type === factorType)
      //   .map((x) => {
      //     const splitedArr = x.dueDate.split('-')
      //     const shamsiDate = MiladiToJalali(Number(splitedArr[0]), Number(splitedArr[1]), Number(splitedArr[2]))
      //     return ({
      //       ...x,
      //       ind: x.accountingCode,
      //       title: x.title + " - " + `${shamsiDate[0]}/${shamsiDate[1] < 10 ? '0' + shamsiDate[1] : ""}/${shamsiDate[2]} ` + ` - ${formatPrice(x.totalPrice)} ${getDefaultCurrency(x.CurrencyId).en_title} `,
      //       label: x.accountingCode + " - " + x.title + " - " + `${shamsiDate[0]}/${shamsiDate[1] < 10 ? '0' + shamsiDate[1] : ""}/${shamsiDate[2]}` + ' - ' + `${x.totalPrice} ${getDefaultCurrency(x.CurrencyId).fa_title}`,
      //       value: x.id,
      //     })
      //   }),
      withRefresh: true,
      withSearch: true,
      // refreshList: () =>
      //   dispatch(apiFactorsList(token, JSON.stringify([factorType]), "transaction", data.person)),
      onChange: async (val, option) => {
        const fPrice = option.remaining;
        let d = await handleChange(val, "factor");
        d = await handleChange(option, "factorOption", null, d);
        if (fPrice) d = await handleChange(fPrice, "price", null, d);
      },
    },
    cost: {
      type: "select",
      label: "انتخاب حساب",
      isNested: true,
      withSearch: true,
      withRefresh: true,
      options: costTypes,
      refreshList: () => dispatch(apiGetAccountingTypes(token, "cost")),
    },
    income: {
      type: "select",
      label: "انتخاب حساب",
      isNested: true,
      withSearch: true,
      withRefresh: true,
      options: incomeTypes,
      refreshList: () => dispatch(apiGetAccountingTypes(token, "income")),
    },

    price: {
      type: "text",
      label: "مبلغ",
      inputProps: { type: "price", prefix: props.currency?.en_title },
    },
    reference: { type: "text", label: "ارجاع" },
  };

  const options: CardProps["options"] = [
    { label: "شخص", value: "person", icon: IconLogoPerson2 },
    { label: "حساب  هزینه ها", value: "cost", icon: costImage, active: props.tab === 1 },
    { label: "حساب  درآمد ها", value: "income", icon: incomeImage, active: props.tab === 0 },
  ];

  const inputsToShow: any = {
    person: ["person", "factor", "price"],
    cost: ["cost", "price", "reference"],
    income: ["income", "price", "reference"],
  };

  const requiredInputs: any = {
    person: ["person", "price"],
    cost: ["cost", "price"],
    income: ["income", "price"],
  };

  const typeOptionKeys = ["person", "cost", "income"];
  const typeOption = data.typeOption || {};

  function Footer({ title, type, callBack }: { title: string; type: string; callBack?: any }) {
    return (
      <BasicButton
        onClick={() => {
          dispatch(
            appSetModal({
              component: type,
              title: title,
              closeButton: true,
              onFinish: (token: any, res: any) => {
                res && callBack && callBack(token, res);
              },
            })
          );
        }}
      >
        <PlusIcon scale={0.7} /> <span>{title}</span>
      </BasicButton>
    );
  }

  function handleChange(val: any, key: any, option?: any, d?: SourceData) {
    return new Promise<SourceData>((resolve) => {
      if (Array.isArray(val)) {
        val = val[0];
      }
      let typeOption;
      if (typeOptionKeys.includes(key) && option) {
        typeOption = option;
        typeOption.title = typeOption.nickName || typeOption.title;
      }
      const newData = { ...(d || data), [key]: val, ...(!!typeOption && { typeOption }) };
      setData(newData);
      props.onChange &&
        props.onChange({
          data: newData,
          type,
          icon: options?.find((x) => x.value === type)?.icon,
          ...(!!typeOption && { typeOption }),
          done: done(newData),
        });
      resolve(newData);
    });
  }

  function handleTypeChange(val: any) {
    setType(val);
    setData({});
    props.onChange && props.onChange({ data: {}, type: val });
  }

  function done(data: any) {
    let required = requiredInputs[type];
    const valid = !required.find((x: any) => !data[x]);
    return valid;
  }
  return (
    <ClickAwayListener
      onClickAway={() => {
        if (done(data) && !!edit) {
          setEdit(false);
          props.onChangeEdit && props.onChangeEdit(false);
        }
      }}
    >
      <div>
        <Card
          {...{
            inputs,
            inputsToShow,
            options,
            data,
            type,
            forceType: props.forceType,
            index: props.index,
            onTypeChange: handleTypeChange,
            onChange: (data) => handleChange(data.val, data.key, data.option),
            onChangeEdit: (edit) => props.onChangeEdit && props.onChangeEdit(edit),
            onDelete: props.onDelete,
            edit,
            currency: props.currency,
            info: {
              icon: options.find((x) => x.value === type)?.icon || "",
              dsc: <></>,
              price: data.price || 0,
              title: typeOption.title,
              ind: typeOption.accountingCode,
              isPositive: props.tab === 0,
            },
            justShow: props.justShow,
          }}
        />
      </div>
    </ClickAwayListener>
  );
}
